import { stringify } from "query-string";
import {
  GET_LIST,
  GET_ONE,
  GET_MANY,
  GET_MANY_REFERENCE,
  CREATE,
  UPDATE,
  DELETE,
  DELETE_MANY
} from "react-admin";
import { auth } from "../../firebase";
import { QA_API_ERROR } from "../../util";

const AnswerProvider = opt => {
  const { config, httpClient } = opt;
  if (!config) {
    throw new Error("Missing config");
  }
  if (!httpClient) {
    throw new Error("Missing httpClient");
  }
  const provider = {
    handle(type, params) {
      switch (type) {
        case GET_LIST:
          return provider.list(params);
        case GET_MANY_REFERENCE:
          return provider.list(params);
        case GET_ONE:
          return provider.get(params);
        case GET_MANY:
          return provider.getMany(params);
        case CREATE:
          return provider.create(params);
        case UPDATE:
          return provider.update(params);
        case DELETE:
          return provider.delete(params);
        case DELETE_MANY:
          return provider.deleteMany(params);
        default:
          throw new Error(`Unsupported action type: ${type}`);
      }
    },
    get(params) {
      return httpClient
        .get(`/api/admin/answer/${params.id}`)
        .then(res => res.data)
        .then(result => {
          if (result.status !== "success") {
            throw QA_API_ERROR("AnswerProvider.get Error", result, params);
          }
          let response = {
            data: result.answer
          };
          return response;
        });
    },
    getMany(params) {
      const query = {
        ids: params.ids
      };
      return httpClient
        .get(`/api/admin/answers?${stringify(query)}`)
        .then(res => res.data)
        .then(result => {
          if (result.status !== "success") {
            throw QA_API_ERROR("AnswerProvider.getMany Error", result, params);
          }
          const response = {
            data: result.answers || null
          };
          return response;
        });
    },
    list(params) {
      const query = {
        order: params.sort.field,
        sort: params.sort.order.toLowerCase(),
        limit: params.pagination.perPage
      };
      // target
      if (params.target === "questionId") {
        query.questionId = params.id;
      }
      if (params.target === "authorId") {
        query.authorId = params.id;
      }
      // filter
      if (params.filter.questionId) {
        query.questionId = params.filter.questionId;
      }
      if (params.filter.author) {
        query.authorId = params.filter.author.id;
      }
      // pagination
      if (typeof params.pagination.page === "string") {
        const [pageNumber, afterOrBefore, id] = params.pagination.page.split(
          "_"
        );
        if (afterOrBefore === "after") {
          query.after = id;
        } else if (afterOrBefore === "before") {
          query.before = id;
        }
        console.log("pageNumber: ", pageNumber);
      }
      return httpClient
        .get(`/api/admin/answers?${stringify(query)}`)
        .then(res => res.data)
        .then(result => {
          if (result.status !== "success") {
            throw QA_API_ERROR("AnswerProvider.list Error", result, params);
          }
          let response = {
            data: result.answers || null,
            total: 1000
          };
          return response;
        });
    },
    create(params) {
      return auth.currentUser
        .getIdToken(false)
        .then(token => {
          const payload = {
            token,
            content: params.data.content,
            questionId: params.data.questionId,
            authorId: params.data.authorId
          };
          if (params.data.images && params.data.images.length) {
            payload.images = params.data.images;
          }
          if (params.data.publishDate) {
            payload.publishDate = params.data.publishDate.toISOString();
          }
          return httpClient.post(`/api/admin/answers`, payload);
        })
        .then(res => res.data)
        .then(result => {
          if (result.status !== "success") {
            throw QA_API_ERROR("AnswerProvider.create Error", result, params);
          }
          const response = {
            data: result.answer
          };
          return response;
        });
    },
    update(params) {
      return auth.currentUser
        .getIdToken(false)
        .then(token => {
          const payload = {
            token,
            content: params.data.content.text || null,
            images: params.data.content.images || null,
            time: params.data.time || null,
            status: params.data.status || null
          };
          return httpClient.put(`/api/admin/answer/${params.id}`, payload);
        })
        .then(res => res.data)
        .then(result => {
          if (result.status !== "success") {
            throw QA_API_ERROR("AnswerProvider.update Error", result, params);
          }
          const response = {
            data: result.answer
          };
          return response;
        });
    },
    delete(params) {
      return auth.currentUser
        .getIdToken(false)
        .then(token => {
          const payload = {
            token
          };
          return httpClient.delete(`/api/admin/answer/${params.id}`, {
            data: payload
          });
        })
        .then(res => res.data)
        .then(result => {
          if (result.status !== "success") {
            throw QA_API_ERROR("AnswerProvider.delete Error", result, params);
          }
          const response = {
            data: result.answer
          };
          return response;
        });
    },
    deleteMany(params) {
      return auth.currentUser
        .getIdToken(false)
        .then(token => {
          const payload = {
            token,
            ids: params.ids
          };
          return httpClient.delete(`/api/admin/answers`, { data: payload });
        })
        .then(res => res.data)
        .then(result => {
          if (result.status !== "success") {
            throw QA_API_ERROR(
              "AnswerProvider.deleteMany Error",
              result,
              params
            );
          }
          const response = {
            data: result.deletedIds
          };
          return response;
        });
    }
  };
  return provider;
};

export default AnswerProvider;
